









import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { getHexadecimalValue } from '../utils';

@Component({
    components: {

    }
})
export default class HexadecimalValue extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {

    @Prop({default: ''}) value: string;

    parseNumberToHex(value) {
        return getHexadecimalValue(value);
    }
   
}
